module.exports = __webpack_public_path__ + "img/bottom_icon_home_t.7c574626.svg";